<template>
  <div class="sidebar-left">
    <div class="logo">
      <router-link :to="{name: 'Home'}">
        <img src="/assets/images/logo.png?version=2.0" alt="Logo">
        <img src="/assets/images/logo-simple.png" alt="LogoSimple">
      </router-link>
    </div>
    <ul class="main-menu">
      <li>
        <router-link :to="{name: 'Dashboard'}" class="menu-item"><i class="bx bxs-dashboard"></i><span>{{ $t('MENU_DASHBOARD') }}</span></router-link>
      </li>
      <li>
        <router-link :to="{name: 'profile'}" class="menu-item"><i class="bx bx-user"></i><span>{{ $t('MENU_PROFILE') }}</span></router-link>
      </li>
      <li v-if="false">
        <router-link :to="{name: 'kyc'}" class="menu-item"><i class="bx bx-shield-quarter"></i><span>KYC</span></router-link>
      </li>
      <li>
        <a class="menu-item menu-logout" @click.prevent="logout()"><i class="bx bx-log-out-circle"></i><span>{{ $t('MENU_LOGOUT') }}</span></a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isCollapsedMenu: false
    }
  },
  methods: {
    logout () {
      this.$confirm('Logout', this.$t('TEXT_CONFIRM'), {
        confirmButtonText: this.$t('BTN_OK'),
        cancelButtonText: this.$t('BTN_CANCEL'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
      }).catch(() => {
      })
    }
  }
}
</script>
